"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLoader = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconLoader = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
  id: "icon-loader_svg__a",
  x1: "85.527%",
  x2: "0%",
  y1: "0%",
  y2: "82.658%"
}, /*#__PURE__*/_react.default.createElement("stop", {
  offset: "0%",
  stopColor: "#951C20"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "100%",
  stopColor: "#951C20",
  stopOpacity: 0
}))), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 4
}, /*#__PURE__*/_react.default.createElement("path", {
  stroke: "#951C20",
  d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2"
}), /*#__PURE__*/_react.default.createElement("path", {
  stroke: "url(#icon-loader_svg__a)",
  d: "M0 20c5.523 0 10-4.477 10-10",
  transform: "matrix(0 1 1 0 2 12)"
})));
exports.IconLoader = IconLoader;
//# sourceMappingURL=IconLoader.js.map